import Head from 'next/head'
import type { GetStaticPaths, GetStaticProps } from 'next'

import { Nav } from '@/templates/Inc/Nav'
import { SolutionsTemplate } from '@/templates/Inc/Solutions'
import { TEN_MINS_REVALIDATION } from '@/utils/constants/revalidation'
import {
  getSolutionData,
  solutionSlugs,
  type SolutionPageData
} from '@/data/solutions'
import Footer from '@/cmp/molecules/Footer/Footer'

type Props = {
  slug: string
  solutionData: SolutionPageData
}

const SolutionDetailsPage = ({ solutionData }: Props) => {
  return (
    <>
      <Head>
        <title>{solutionData.metadata.seoTitle}</title>
        <meta
          name="description"
          content={solutionData.metadata.seoDescription}
        />
        <link rel="canonical" href={solutionData.metadata.canonicalUrl} />
      </Head>
      <Nav />
      <SolutionsTemplate solutionData={solutionData} />
      <div className="pt-20">
        <Footer />
      </div>
    </>
  )
}

export const getStaticProps: GetStaticProps = async ({ params }) => {
  const slug = params?.slug?.toString() ?? ''

  // Get solution data
  const solutionData = getSolutionData(slug)

  // Return 404 if slug is not valid
  if (!solutionData) {
    return {
      notFound: true
    }
  }

  return {
    props: {
      slug,
      solutionData
    },
    revalidate: TEN_MINS_REVALIDATION
  }
}

export const getStaticPaths: GetStaticPaths = async () => {
  // Generate paths for all solution slugs
  const paths = solutionSlugs.map(slug => ({
    params: { slug }
  }))

  return {
    paths,
    fallback: false // Return 404 for any slug not in our data
  }
}

export default SolutionDetailsPage
